import React from 'react';
import './ElectionPrediction.css';

const ElectionPrediction = () => {
  const predictions = [
    { party: 'Coalition', seats: 51, color: '#1E3D8F' },
    { party: 'Labor Party', seats: 78, color: '#E13940' },
    { party: 'Independents', seats: 14, color: '#800080' },
    { party: 'Greens', seats: 5, color: '#2E8B57' },
    { party: "Katter's Australian Party", seats: 1, color: '#FFD700' },
    { party: 'Centre Alliance', seats: 1, color: '#FFA500' }
  ];

  const totalSeats = predictions.reduce((sum, p) => sum + p.seats, 0);
  const scaleFactor = 1.5; // Scale factor for better visualization

  return (
    <div className="election-prediction">
      <h2>2025 Election Prediction</h2>
      <div className="prediction-summary">
        <p className="prediction-title">Labor majority government</p>
      </div>
      <div className="seats-visualization">
        {predictions.map((prediction, index) => {
          let width = (prediction.seats / totalSeats) * 100 * scaleFactor;
          
          // Scale up Greens bar to make it more visible
          if (prediction.party === 'Greens') {
            width *= 1.5;
          }
          
          return (
            <div key={index} className="seat-bar">
              <div
                className="seat-fill" 
                style={{
                  width: `${width}%`,
                  backgroundColor: prediction.color
                }}
              >
                <span className="seat-count">{prediction.seats}</span>
              </div>
              <span className="party-name">{prediction.party}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ElectionPrediction; 